// Both the status row and the detail block derive the id from the same vendor + owner pair. Matching on the
// block title instead would break on Au10tix, whose title comes from the scanned document rather than the owner.
export const getDddBlockAnchorId = (
    vendor: string | null | undefined,
    ownerId?: string | null,
    idPrefix = '',
): string | null => {
    if (!vendor) {
        return null;
    }

    const suffix = ownerId ? `-${ownerId}` : '';

    return `${idPrefix}ddd-block-${vendor.toLowerCase()}${suffix}`;
};
